/* ADD GROUPS */
export const ADD_GROUP_COURSE = "ADD_GROUP_COURSE"
export const ADD_GROUP_COURSE_SUCCESS = "ADD_GROUP_COURSE_SUCCESS"
export const ADD_GROUP_COURSE_CLEAN = "ADD_GROUP_COURSE_CLEAN"
export const ADD_GROUP_COURSE_ERROR = "ADD_GROUP_COURSE_ERROR"
